"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const _tagged_template_literal = require("@swc/helpers/_/_tagged_template_literal");
function _templateObject() {
    const data = _tagged_template_literal._([
        "\n  ",
        "\n  fragment ProductListingFacetsRows on EditorialPlpRowsContent {\n    facets {\n      ...ProductListingFacets\n    }\n    rows {\n      content {\n        ... on Product {\n          productCode\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.productListingFacetsRows = void 0;
var _fetching = require("@ori/fetching");
var _productListingFacets = require("./productListingFacets");
const productListingFacetsRows = exports.productListingFacetsRows = (0, _fetching.gql)(_templateObject(), _productListingFacets.productListingFacets);
